import classNames from "classnames";
import { toast, ToastContainer, ToastPosition } from "react-toastify";
import { useBreakpoint } from "hooks/useBreakpoint";
import useTranslate from "hooks/useTranslate";
import ToastButtonClose from "components/atoms/ToastButtonClose";
import { CustomToastProps, ParametersSentToast } from "./types";
import { ICONS_TOASTS } from "./constants";
import "./styles.sass";

const CustomToast = ({ title, subtitle }: CustomToastProps) => {
  const t = useTranslate();

  return (
    <div className="ToastInner">
      <div className="ToastInner__content">
        <h3 className="ToastInner__title">{t(title)}</h3>
        {subtitle ? (
          <p className="ToastInner__description">{t(subtitle)}</p>
        ) : null}
      </div>
    </div>
  );
};

export const sendToast = (params: ParametersSentToast) =>
  toast(
    <CustomToast
      title={params.title}
      subtitle={params.subtitle}
      variant={params.variant}
    />,
    {
      ...params,
      className: classNames(
        "Toast",
        params?.variant && `Toast_${params.variant}`,
      ),
      progressClassName: classNames(
        "Toast__progressbar",
        params?.variant && `Toast__progressbar_${params.variant}`,
      ),
      bodyClassName: "Toast__body",
      icon:
        !params.withoutIconInfo &&
        params?.variant &&
        ICONS_TOASTS[params.variant]
          ? ICONS_TOASTS[params.variant]
          : undefined,
    },
  );

// eslint-disable-next-line react/no-multi-comp
const Toast = () => {
  const { isDesktop } = useBreakpoint();
  const position: ToastPosition = isDesktop ? "top-right" : "bottom-left";

  return (
    <ToastContainer
      position={position}
      className="Toast__container"
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      closeButton={<ToastButtonClose />}
    />
  );
};

export default Toast;
